import * as businessAPI from "../../api/business";
import {
  createDashboardMutationThunk,
  createDashboardQueryThunk,
  createEntityListSlice,
  createEntityListStateUpdater,
} from "../utils/createEntityListSlice";

const updateBusinessList = createEntityListStateUpdater("businessList");
const updateBusinessListState = (state, action) => {
  updateBusinessList(state, action);
  const list = state.data?.businessList;
  const item = Array.isArray(list)
    ? list.find((business) => business.id === action.meta?.arg?.id)
    : null;
  if (item && Number.isSafeInteger(action.payload?.revision)) {
    item.revision = action.payload.revision;
  }
};

const getBusiness = createDashboardQueryThunk(
  "business/getBusiness",
  businessAPI.getBusiness,
  "Failed to load business data"
);

const searchBusiness = createDashboardQueryThunk(
  "business/searchBusiness",
  businessAPI.searchBusiness,
  "Business search failed"
);

const searchBusinessWithClient = createDashboardQueryThunk(
  "business/searchBusinessWithClient",
  businessAPI.searchBusinessByClient,
  "Business search failed"
);

const addBusiness = createDashboardMutationThunk(
  "business/addBusiness",
  businessAPI.addBusiness,
  {
    fallbackMessage: "Failed to add business",
    getSuccessMessage: "Business Added Successfully",
  }
);

const updateBusiness = createDashboardMutationThunk(
  "business/updateBusiness",
  businessAPI.updateBusiness,
  {
    fallbackMessage: "Failed to update business",
    getSuccessMessage: (params) =>
      params?.status === "Deactive"
        ? "Business Deleted Successfully"
        : "Business Updated Successfully",
  }
);

const webScript = createDashboardQueryThunk(
  "business/webScript",
  businessAPI.webScript,
  "Failed to load script"
);

const webScriptV2 = createDashboardQueryThunk(
  "business/webScriptV2",
  businessAPI.webScriptV2,
  "Failed to load scripts"
);

const getBusinessByClient = createDashboardQueryThunk(
  "business/getBusinessByClient",
  businessAPI.getClientBusiness,
  "Failed to load client business"
);

const getBusinessWithClientId = createDashboardQueryThunk(
  "business/getBusinessWithClientId",
  businessAPI.getBusinessByClient,
  "Failed to load business list"
);

const getBusinessForBusinessUser = createDashboardQueryThunk(
  "business/getBusinessForBusinessUser",
  businessAPI.getBusinessForBusiness,
  "Failed to load business data"
);

const businessSlice = createEntityListSlice({
  name: "business",
  extraState: {
    scriptData: null,
    scriptVariants: null,
    clientBusiness: null,
  },
  asyncCases: [
    { thunk: getBusiness },
    { thunk: searchBusiness },
    {
      thunk: searchBusinessWithClient,
      options: {
        onRejected: (state) => {
          state.data = null;
        },
      },
    },
    { thunk: addBusiness },
    {
      thunk: updateBusiness,
      options: {
        onFulfilled: updateBusinessListState,
      },
    },
    {
      thunk: webScript,
      options: {
        dataKey: "scriptData",
      },
    },
    {
      thunk: webScriptV2,
      options: {
        dataKey: "scriptVariants",
      },
    },
    {
      thunk: getBusinessByClient,
      options: {
        loadingKey: null,
        onFulfilled: (state, action) => {
          state.clientBusiness = action.payload?.businessList;
        },
        onRejected: (state) => {
          state.clientBusiness = [];
        },
      },
    },
    {
      thunk: getBusinessWithClientId,
      options: {
        onRejected: (state) => {
          state.data = [];
        },
      },
    },
    {
      thunk: getBusinessForBusinessUser,
      options: {
        onRejected: (state) => {
          state.data = [];
        },
      },
    },
  ],
});

const { resetState, setPageNumber, setRowsPerPage } = businessSlice.actions;

export default businessSlice.reducer;

export {
  getBusiness,
  resetState,
  searchBusiness,
  addBusiness,
  updateBusiness,
  setPageNumber,
  setRowsPerPage,
  webScript,
  webScriptV2,
  getBusinessByClient,
  getBusinessWithClientId,
  searchBusinessWithClient,
  getBusinessForBusinessUser,
};
